import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import InputWithOptions from '../InputWithOptions/InputWithOptions';

var AutoComplete = /*#__PURE__*/function (_InputWithOptions) {
  _inherits(AutoComplete, _InputWithOptions);

  var _super = _createSuper(AutoComplete);

  function AutoComplete() {
    _classCallCheck(this, AutoComplete);

    return _super.apply(this, arguments);
  }

  _createClass(AutoComplete, [{
    key: "dropdownAdditionalProps",
    value: function dropdownAdditionalProps() {
      var _this$props = this.props,
          options = _this$props.options,
          predicate = _this$props.predicate,
          emptyStateMessage = _this$props.emptyStateMessage;
      var filterFunc = this.state.isEditing ? predicate : function () {
        return true;
      };
      var filtered = options.filter(filterFunc);

      if (emptyStateMessage && filtered.length === 0) {
        return {
          options: [{
            id: 'empty-state-message',
            value: emptyStateMessage,
            disabled: true
          }]
        };
      } else {
        return {
          options: filtered
        };
      }
    }
  }]);

  return AutoComplete;
}(InputWithOptions);

_defineProperty(AutoComplete, "displayName", 'AutoComplete');

_defineProperty(AutoComplete, "propTypes", _objectSpread(_objectSpread({}, InputWithOptions.propTypes), {}, {
  /** Callback predicate for the filtering options function */
  predicate: PropTypes.func,

  /** The message to be displayed instead of options, when no options exist, or no options pass the predicate filter function */
  emptyStateMessage: PropTypes.node
}));

_defineProperty(AutoComplete, "defaultProps", _objectSpread(_objectSpread({}, InputWithOptions.defaultProps), {}, {
  predicate: function predicate() {
    return true;
  }
}));

export default AutoComplete;